import { ChangeField, Checklist } from "../ServiceChecklists/Components/types";

export enum ServiceReportTabs {
  DETAILS = "Details",
  CHECKLIST = "Checklist",
}

export type FileData = {
  name: string;
  type: string;
  uri: string;
};
export type ImageData = FileData | string;

export enum ANSWER {
  NO = 0,
  YES = 1,
  NA = 2,
  FAIL = 3,
  PASS = 4,
}

export enum ASSET_CONDITION {
  OUT_OF_ORDER = 0,
  OPERABLE_BUT_REQUIRES_ATTENTION = 1,
}

export type serviceData = {
  order: number | null;
  question: string;
  answer: ANSWER | null;
  textInput: string;
  images: ImageData[] | [];
  notes: string;
  assetCondition: ASSET_CONDITION | null;
};

export enum ServiceResultText {
  PASSED = 'Passed',
  FAILED_OPERABLE = 'Failed - Operable',
  FAILED_OUT_OF_ORDER = 'Failed - Out of Order',
  NOT_SERVICED = 'Not Serviced',
  FAILED = 'Failed',
}


export enum ServiceResult {
  FAILED_OUT_OF_ORDER = 0,
  PASSED = 1,
  FAILED_OPERABLE = 2,
  NOT_SERVICED = 3,
  FAILED = 4,
}

export enum toolServiceStatuses {
  SCHEDULED = 'Scheduled',
  DUESOON = 'Due Soon',
  UNSCHEDULED = 'Unscheduled',
  CANCELLED = 'Cancelled',
  OVERDUE = 'Overdue',
  FAILED = 'Failed',
}

export enum ServiceStatus {
  SCHEDULED= 1,
  CANCELLED = 2,
  COMPLETED = 3,
}

export enum ServiceStatusText {
  SCHEDULED= 'Scheduled',
  CANCELLED = 'Cancelled',
  COMPLETED = 'Completed',
}

export type User = {
  userId: string;
  firstName: string;
  lastName: string;
  email?: string;
};

export type ServiceReport = {
  _id: string;
  assetCategoryId: string;
  serialNumber: string;
  servicingTemplateId: string;
  serviceTitle: string;
  serviceType: string;
  serviceChecklist: serviceData[];
  finalNotes?: string | null;
  preServiceInstructions?: string;
  failedServiceInstructionsOperable?: string;
  failedServiceInstructionsOutOfOrder?: string;
  checklistTemplates: Checklist[];
  serviceResult: ServiceResult;
  signature: ImageData;
  servicedOn: string;
  servicedBy: User;
  editorSignature?: ImageData;
  nextServiceDueDate?: string;
  nextServiceReminderDate?: string;
  previousServiceDueDate?: string;
  previousServiceReminderDate?: string;
};


// Type for service report history tracking
export type ServiceReportHistoryData = {
  _id: string;
  serviceReportId: string; 
  serialNumber: string;
  updatedOn: Date;
  updatedBy: User;
  serviceResult?: ChangeField;
  finalNotes?: ChangeField;
  editorSignature?: ChangeField;
  checklistChanges: ReportChecklistItemChange[];
};

export type HistoryEntryComponentProps = {
  item: ServiceReportHistoryData;
}

// Types for tracking changes to individual checklist items
export type ReportChecklistItemChange = {
  order: number; // To identify which checklist item was changed
  question: string; // Store the question text for reference
  answer?:ChangeField;
  textInput?: ChangeField;
  images?: ChangeField;
  notes?: ChangeField;
  assetCondition?: ChangeField;
};


